var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlagRoundUa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19_917)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.6667 7.91663H6.33333C4.65363 7.91663 3.04272 8.58389 1.85499 9.77162C0.66726 10.9593 0 12.5703 0 14.25L0 28.5H57V14.25C57 12.5703 56.3327 10.9593 55.145 9.77162C53.9573 8.58389 52.3464 7.91663 50.6667 7.91663Z",
    fill: "#005BBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57 42.75C57 44.4297 56.3327 46.0406 55.145 47.2283C53.9573 48.4161 52.3464 49.0833 50.6667 49.0833H6.33333C4.65363 49.0833 3.04272 48.4161 1.85499 47.2283C0.66726 46.0406 0 44.4297 0 42.75V28.5H57V42.75Z",
    fill: "#FFD500"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19_917"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 57,
    height: 57,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagRoundUa);
export default __webpack_public_path__ + "static/media/flag_round_ua.9215b1fb65b0a92e9e5b29395a9df94b.svg";
export { ForwardRef as ReactComponent };